import { render, staticRenderFns } from "./PermissionsMatrix.vue?vue&type=template&id=45c8a532&scoped=true&"
import script from "./PermissionsMatrix.vue?vue&type=script&lang=js&"
export * from "./PermissionsMatrix.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsMatrix.vue?vue&type=style&index=0&id=45c8a532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8a532",
  null
  
)

export default component.exports